import CandidatesInvitedContainer from './candidates_invited_container';

const CandidatesInvited = CandidatesInvitedContainer;
export default CandidatesInvited;
